module.exports = __webpack_public_path__ + "static/media/w-logo.447712cf.png";